import './Menu.css';
import _ from 'lodash';
import $ from 'jquery';
import Backbone from 'backbone';
import Tools from 'util/Tools';
import {appReady} from 'common/appReady';
import {Key} from 'util/Key';

const sharedEventBus = new Backbone.View();
const $menuWrapper = $('<div class="DropDownMenuWrapper unselectableText" data-role="none"></div>');
appReady.then(() => {
	$('body').append($menuWrapper);
});


/////////////////////////////////
////////// DropDown /////////////
/////////////////////////////////
/**
 * connects a drop down menu to a $button
 */
export const DropDownView = Backbone.View.extend({
	className: "DropDownMenu",
	events: {
		click: "clickMenuHandler",
		mouseleave: "closeOnMouseLeave",
	},
	/**
	 * @param options
	 * @param {jQuery | HTMLElement} options.$button area that opens the menu
	 * @param {jQuery | HTMLElement} options.$positionTo area where the menu opens
	 * @param {Array} options.views content of drop down menu
	 * @param {Object} options.positionOptions forwarded to util/Tools.positionTo
	 * @param {Object} options.buttonEventNames set to "click" if you do want disable open on hover
	 * @param {boolean} options.closeAfterSelection close menu when: click anywhere in menu, mouseleave menu
	 */
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.status = new Backbone.Model({
			visible: false,
			disabled: false,
			fixed: false,
		});
		this.positionOptions = options.positionOptions;
		this.closeAfterSelection = options.closeAfterSelection !== false;
		this.childViews = this.generateChildViews(options);
		this.$el.hide();
		if (options.buttonEventNames) this.buttonEventNames = options.buttonEventNames;
		this.setExternalElements(options.$button, options.$positionTo);
		this.listenTo(sharedEventBus, 'all', this.sharedEventHandler);
		this.listenTo(this.status, 'change:visible', this.refreshVisible);
		this.listenTo(this.status, 'change:visible', this.evtVisible);
		this.listenTo(this.status, 'change:disabled', this.evtDisabled);
		this.listenTo(this.status, 'change:fixed', this.evtFixed);
		this.render();
		$menuWrapper.append(this.el);
	},
	setExternalElements: function ($button, $positionTo) {
		if (this.$button) this.$button.off(this.buttonEventNames, null, this.buttonListenerCb);
		this.$button = $($button);
		if (this.$button.length) this.$button.on(this.buttonEventNames, null, this.buttonListenerCb);
		this.$positionTo = $($positionTo);
		if (!this.$positionTo.length) this.$positionTo = this.$button;
	},
	disable: function () {
		this.status.set({disabled: true});
	},
	enable: function () {
		this.status.set({disabled: false});
	},
	// ********************************
	// **** Ext Listener Callbacks ****
	// ********************************
	buttonEventNames: "click mouseover",
	buttonListenerCb: function buttonListenerCb(evt) {
		if (this.status.get('disabled')) return;
		switch (evt.type) {
			case "click":
				if (this.status.get('fixed')) this.status.set({visible: false, fixed: false});
				else this.status.set({visible: true, fixed: true});
				break;
			case "mouseover":
				this.status.set({visible: true});
				break;
		}
	},
	globalEventNames: 'click',
	globalListenerCb: function globalListenerCb(evt) {
		let eventInside = $(evt.target).closest(this.el).length ||
			(this.$button && $(evt.target).closest(this.$button[0]).length);
		switch (evt.type) {
			case "click":
			default:
				if (eventInside) return;
				this.status.set({visible: false, fixed: false});
				break;
		}
	},
	closeOnMouseLeave: function () {
		if (!this.status.get('fixed') && !$(document.activeElement).closest(this.el).length) {
			this.status.set({visible: false});
		}
	},
	// ***********************
	// **** Event Handler ****
	// ***********************
	keyDownHandler: function (evt) {
		//keycode handlings
		switch (evt.key) {
			case Key.Escape:
				this.status.set({visible: false, fixed: false});
				return false;
			default:
				return true; //do nothing
		}
	},
	clickMenuHandler: function (evt) {
		let $target = $(evt.target).closest('.ddmvButton');
		let invoke = $target.attr('data-invoke');
		if (invoke && typeof this[invoke] == 'function') this[invoke]();
		if (this.closeAfterSelection) this.status.set({fixed: false, visible: false});
		evt.stopImmediatePropagation();
		evt.preventDefault();
		return false;
	},
	sharedEventHandler: function (eventName, data) {
		switch (eventName) {
			case "showMenu":
				if (data !== this) this.status.set({visible: false, fixed: false});
				break;
		}
	},
	evtDisabled: function () {
		let status = this.status.get('disabled');
		if (status) this.status.set({visible: false, fixed: false});
		this.$button.toggleClass('disabled', status);
	},
	evtVisible: function () {
		if (!this.status.get('visible')) this.trigger('close');
		else this.trigger('open');
	},
	refreshVisible: function () {
		let status = this.status.get('visible');
		$(document).off(this.globalEventNames, null, this.globalListenerCb);
		if (status) {
			this.refreshChildViews();
			Tools.positionTo(this.$el, this.$positionTo, this.positionOptions);
			$(document).on(this.globalEventNames, null, this.globalListenerCb);
			this.$el.show();
			sharedEventBus.trigger('showMenu', this);
		} else {
			this.status.set({fixed: false});
			this.$el.hide();
		}
	},
	evtFixed: function () {
		let status = this.status.get('fixed');
		if (!status) this.refreshVisible();
	},
	refreshChildViews: function () {
		if (!this.childViews) return;
		_.each(this.childViews, function (v) {
			v.trigger('refresh');
		});
	},
	removeChildViews: function () {
		if (this.childViews) {
			_.each(this.childViews, function (v) {
				v.remove();
			});
		}
		this.childViews = [];
	},
	remove: function () {
		this.removeChildViews();
		return this.constructor.prototype.remove();
	},
	generateChildViews: function (options) {
		return options.views || [];
	},
	render: function () {
		this.$el.html(this.childViews.map(function (view) {
			return view.el;
		}));
		return this;
	},
});


/////////////////////////////////////////////
////////// Menu Items Helper / /////////////
///////////////////////////////////////////
const DEFAULT = 'DEFAULT';
/**
 * state attributes: see template in ItemView (label, icon, active, ...)
 */
const ItemModel = Backbone.Model.extend({
	defaults: {
		states: {}, //'DEFAULT' and delta states by getterCb return values
		setterCb: undefined, // triggers external action
		getterCb: undefined, // gets internal status (true|false) after setterCb()
	},
	initialize: function () {
		this.set(this.get('states')[DEFAULT]);
		this.refresh();
	},
	invokeCb: function () {
		let setterCb = this.get('setterCb');
		if (typeof setterCb === 'function') {
			setterCb();
		}
	},
	refresh: function () {
		let getterCb = this.get('getterCb');
		if (typeof getterCb === 'function') {
			let states = this.get('states');
			let s = getterCb();
			if (states[s]) this.set(states[s]);
			else this.set(this.get('states')[DEFAULT]);
		}
	},
});

const ItemView = Backbone.View.extend({
	className: 'MenuItem',
	events: {
		"click": "invokeCb",
	},
	initialize: function (options) {
		this.parent = options.parent;
		this.listenTo(this, 'refresh', this.refresh);
		this.listenTo(this.model, 'change', this.render);
		this.render();
	},
	invokeCb: function () {
		this.model.invokeCb();
		this.parent.refreshChildViews();
	},
	refresh: function () {
		this.model.refresh();
	},
	template: _.template('<div class="MenuInline MenuIcon"><i class="fa <%= m.icon %>"></i></div>\n<div class="MenuInline MenuLabel"><%= m.label %></div>\n'),
	render: function () {
		this.$el.toggleClass('MenuActive', !!this.model.get('active'));
		this.$el.toggleClass('MenuInactive', !this.model.get('active'));
		this.$el.html(this.template({m: this.model.attributes}));
		return this;
	},
});

export const DropDownItemsView = DropDownView.extend({
	/**
	 * @param options all from DropDownView except childViews
	 * @param {[]} options.items example:
	 * items:[{
						setterCb: this.toggleFavoritesFilter,
						getterCb: () => this.getStatus(+moment()),
						states: {
							DEFAULT: {label: 'Favoriten', active: false, icon: 'fa-star-o'},
							'true': {label: 'Alle anzeigen', active: true, icon: 'fa-star'}
						}
					},...]
	 */
	initialize: function (options) {
		this.items = options.items;
		DropDownView.prototype.initialize.call(this, options);
	},
	/**@override*/
	generateChildViews: function (options) {
		return _.map(options.items, (item) => {
			return new ItemView({
				model: item instanceof ItemModel ? item : new ItemModel(item),
				parent: this,
			});
		});
	},
});

export default {
	/**
	 * just the dropdown with array of views
	 */
	DropDownView: DropDownView,
	/**
	 * model generation in {items}
	 */
	DropDownItemsView: DropDownItemsView,
};